import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export function useBillComApi() {
    const callApi = useApiCall();

    const checkTestConnection = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.TEST_CONNECTION, data, onSuccess, onError);
    };

    const saveConnection = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.SAVE_CONNECTION, data, onSuccess, onError);
    };

    const getBillComConfig = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.GET_BILL_COM_CONFIG, data, onSuccess, onError);
    };

    const syncVendor = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.SYNC_VENDOR, data, onSuccess, onError);
    };

    const getBillComVendors = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.GET_BILL_COM_VENDORS, data, onSuccess, onError);
    };

    const syncDepartment = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.SYNC_DEPARTMENT, data, onSuccess, onError);
    };

    const getBillComDepartments = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BILL_COM.GET_BILL_COM_DEPARTMENTS, data, onSuccess, onError);
    };

    

    return {
        checkTestConnection,
        saveConnection,
        getBillComConfig,
        syncVendor,
        getBillComVendors,
        syncDepartment,
        getBillComDepartments,
    };
}